import { AnalyticsProvider, analyticsProvider } from '@/lib/Analytics/analyticsProvider';
import MiscUtils from '../../utils/MiscUtils';
import * as rudderAnalytics from 'rudder-sdk-js';

declare global {
  interface Window {
    analytics: any;
    rudderanalytics: typeof rudderAnalytics;
  }
}

export const ANALYTICS_USER_ID_MAX_LEN = 19;

export default class Analytics {
  /**
   * Tracks the specified Segment event with optional properties
   *
   * @param event {string} Analytics event name
   * @param props {Record<string, any>} Optional --> Properties to track with
   */
  static track(event: string, props?: Record<string, any>) {
    const safeProps = { ...(props || {}) };
    if (process.env.NODE_ENV === 'development') {
      console.log('TRACK::', event, safeProps);
    }
    if (!MiscUtils.isBrowser()) return;
    if (analyticsProvider === AnalyticsProvider.Segment) {
      // @ts-ignore
      global.analytics.track(event, safeProps);
    } else {
      window.rudderanalytics.track(event, safeProps);
    }
  }

  /**
   * Identifies the specified userId with optional traits
   *
   * @param userId {string} User id to to identify, will automatically pad front with 0s to make sure id is max length
   * @param traits {Record<string, any>} Optional --> Properties to identify by
   */
  static identify(userId: string, traits?: Record<string, any>) {
    const paddedUserId = userId?.padStart(ANALYTICS_USER_ID_MAX_LEN, '0');
    const safeTraits = { ...(traits || {}) };
    if (!MiscUtils.isBrowser()) return;
    if (analyticsProvider === AnalyticsProvider.Segment) {
      // @ts-ignore
      global.analytics.identify(paddedUserId, safeTraits);
    } else {
      window.rudderanalytics.identify(paddedUserId, safeTraits);
    }
  }

  /**
   * Group parent child accounts
   *
   * @param groupId string
   * @param traits {Record<string, any}
   */
  static group(groupId: string, traits: Record<string, any>) {
    if (analyticsProvider === AnalyticsProvider.Segment) {
      // @ts-ignore
      global.analytics.group(groupId, {
        ...(traits || {}),
        ...{
          context: {
            group_type: 'Parent Child Accounts',
            group_value: groupId,
          },
        },
      });
    } else {
      window.rudderanalytics.group(groupId, {
        ...(traits || {}),
        ...{
          context: {
            group_type: 'Parent Child Accounts',
            group_value: groupId,
          },
        },
      });
    }
  }

  static createGroup(): string {
    const generatedGroupId = MiscUtils.generateUUID();
    this.group(generatedGroupId, {});
    return generatedGroupId;
  }
}
